<template>
  <v-form v-model="valid" ref="mainForm">
    <data-iterator
      :list="sas.intervenants"
      add-new-text="Ajouter un intervenant"
      :live="{ endpoint: 'sas-intervenants-accreditations', sasId: sas.id, payload: { estMidiScientifique } }"
      :icon="$getIcon('job')"
      :valids="valids"
      ref="dataIterator"
      hidePoints
    >
      <template v-slot:show-mode="{ item }">
        <h3>{{ item.prenom }} {{ item.nom }}</h3>
      </template>
      <template v-slot:edit-mode="{ item }">
        <TextFieldLive code="intervenant_prenom" v-model="item.prenom" :live="liveSasIntervenant(24802, item)" />
        <TextFieldLive code="intervenant_nom" v-model="item.nom" :live="liveSasIntervenant(24803, item)" />
        <CatalogueLive code="intervenant_genre" v-model="item.genre" :live="liveSasIntervenant(24804, item)" />
        <CatalogueLive code="intervenant_titre" v-model="item.titreProfessionnel" :live="liveSasIntervenant(24805, item)" orderBy="code" />
        <MemoLive code="intervenant_biographie" v-model="item.biographie" :live="liveSasIntervenant(24806, item)" />
        <CatalogueLive
          :disabled="estMidiScientifique"
          :ref="'role_' + item.id"
          code="intervenant_role"
          v-model="item.roles"
          :live="liveSasIntervenant(24807, item)"
        />
      </template>
    </data-iterator>
    <v-checkbox class="list_counter_validator my-2 ml-6 p-0 alert_style" :rules="ruleIntervenant" :input-value="valueRuleIntervenant" />
    <CaseACocherLive code="certification_intervenants" v-model="sasAccreditation.certificationIntervenants" :live="liveSasAccreditation(24636)" />
  </v-form>
</template>
<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
import infosGeneralesAccreditation from "@/components/Formulaires/DemandeAccreditation/mixins/infosGeneralesAccreditation"
import { mapGetters } from "vuex"

export default {
  mixins: [StepFormWithValidation, CataloguesHelpers, infosGeneralesAccreditation],
  data() {
    return {}
  },
  props: {
    sas: { type: Object }
  },
  computed: {
    ...mapGetters(["ressourcesByCode"]),
    rulesIntervenant() {
      const codesRoles = this.sas.intervenants.map((intervenant) =>
        intervenant.roles.map((role) => this.getCatalogueCodeById(this.$constants.DESCID.ACCREDITATION.ROLE, role))
      )
      return {
        unFormateur: codesRoles.some((x) => x.includes(this.$constants.CODE.ROLE.FORMATEUR)),
        unAuteur: codesRoles.some((x) => x.includes(this.$constants.CODE.ROLE.AUTEUR)),
        unReviseurFormateur: codesRoles.some(
          (x) => x.includes(this.$constants.CODE.ROLE.REVISEUR) && x.includes(this.$constants.CODE.ROLE.FORMATEUR)
        ),
        unReviseurAuteur: codesRoles.some((x) => x.includes(this.$constants.CODE.ROLE.REVISEUR) && x.includes(this.$constants.CODE.ROLE.AUTEUR))
      }
    },
    valueRuleIntervenant() {
      return (
        this.rulesIntervenant.unFormateur &&
        this.rulesIntervenant.unAuteur &&
        !this.rulesIntervenant.unReviseurFormateur &&
        !this.rulesIntervenant.unReviseurAuteur
      )
    },
    ruleIntervenant() {
      if (this.estMidiScientifique) {
        return []
      }

      return [
        () => this.rulesIntervenant.unFormateur || this.ressourcesByCode("alerte_regle_intervenants_formateur"),
        () => this.rulesIntervenant.unAuteur || this.ressourcesByCode("alerte_regle_intervenants_auteur"),
        () => !this.rulesIntervenant.unReviseurFormateur || this.ressourcesByCode("alerte_regle_intervenants_duos"),
        () => !this.rulesIntervenant.unReviseurAuteur || this.ressourcesByCode("alerte_regle_intervenants_duos")
      ]
    }
  },
  methods: {
    liveSasIntervenant(cle, item) {
      return { endpoint: "sas-intervenants-accreditations", cle: cle, fileId: item.id }
    }
  },
  watch: {
    "sas.sasAccreditation.formatDeFormation"(newValue) {
      if (this.getCatalogueCodeById(this.$constants.DESCID.ACCREDITATION.FORMAT, newValue) === this.$constants.CODE.FORMAT.MIDI_SCIENTIFIQUE) {
        for (const id of this.sas.intervenants.map((x) => x.id)) {
          const ref = this.$refs["role_" + id]
          ref.setValueByCode("Resp")
        }
      }
    }
  }
}
</script>